export default __webpack_public_path__ + "static/media/cancer_Cn.c14886f5.webp";